import axios from "const/axios";

export const fetchEmailLogs = async (filters = {}) => {
  const params = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  const response = await axios.get("/email-logs", { params });
  return (
    response?.data?.data || {
      content: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: params.size || 20,
    }
  );
};

export const fetchEmailLogById = async (id) => {
  const response = await axios.get(`/email-logs/${id}`);
  return response?.data?.data;
};

export const fetchEmailBatches = async (filters = {}) => {
  const params = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  const response = await axios.get("/email-logs/batches", { params });
  return (
    response?.data?.data || {
      content: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: params.size || 20,
    }
  );
};

export const fetchEmailBatch = async (batchId) => {
  const response = await axios.get(`/email-logs/batch/${batchId}`);
  return response?.data?.data;
};

/** Short-lived browser URL for one attachment of a logged email; open in a new tab. */
export const fetchEmailAttachmentUrl = async (logId, index) => {
  const response = await axios.get(`/email-logs/${logId}/attachments/${index}/url`);
  return response?.data?.data?.url;
};
